import { Check } from 'lucide-react';

import { cn } from 'src/lib/utils';

type Props = {
  features?: string[];
  textAccentColor?: string;
  title?: string;
  footer?: string;
};

const BillingPlanFeatures = ({ features = [], textAccentColor, title = 'Core features:', footer }: Props) => {
  if (!features.length) return null;

  return (
    <div className="space-y-2">
      <div className="text-sm text-muted-foreground">{title}</div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2">
            <Check className={cn('size-5 sm:size-7', textAccentColor)} />
            <span className="text-xs sm:text-base text-foreground font-semibold">{feature}</span>
          </li>
        ))}
      </ul>
      {footer && <div className="text-sm text-muted-foreground">{footer}</div>}
    </div>
  );
};

export default BillingPlanFeatures;
